import React from 'react';

import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';

import theme from '../../../../utils/constants';

export default function TradePresenterCardHighlight(props) {
  return (
    <Box
      width={1}
      className={props.categorycolour}
      color={theme.palette.common.white}
      px={2}
      py={0.5}
      display='flex'
      alignItems='center'
    >
      <Typography variant='subtitle2'>
        <small>{props.highlight}</small>
      </Typography>
    </Box>
  );
}
